import { render, staticRenderFns } from "./realTimeData.vue?vue&type=template&id=3f88019a&scoped=true"
import script from "./realTimeData.vue?vue&type=script&lang=js"
export * from "./realTimeData.vue?vue&type=script&lang=js"
import style0 from "./realTimeData.vue?vue&type=style&index=0&id=3f88019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88019a",
  null
  
)

export default component.exports